import '../assets/NcSelect-4aBmXHhA.css';
import "@nextcloud/vue-select/dist/vue-select.css";
import c from "vue";
import { VueSelect as n } from "@nextcloud/vue-select";
import { autoUpdate as d, computePosition as m, offset as b, flip as y, shift as h, limitShift as g } from "@floating-ui/dom";
import { r as L, b as _, a as i } from "./_l10n-BZu8wI2q.mjs";
import { C as S } from "./ChevronDown-HHJdUMN4.mjs";
import { C } from "./Close-BtO5TPBO.mjs";
import v from "../Components/NcEllipsisedOption.mjs";
import { N as O } from "./NcListItemIcon-9um1JI9_.mjs";
import N from "../Components/NcLoadingIcon.mjs";
import { G as p } from "./GenRandomId-BW3iYFf9.mjs";
import { n as B } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
L(_);
const w = {
  name: "NcSelect",
  components: {
    ChevronDown: S,
    NcEllipsisedOption: v,
    NcListItemIcon: O,
    NcLoadingIcon: N,
    VueSelect: n
  },
  props: {
    // Add VueSelect props to $props
    ...n.props,
    ...n.mixins.reduce((l, e) => ({ ...l, ...e.props }), {}),
    /**
     * `aria-label` for the clear input button
     */
    ariaLabelClearSelected: {
      type: String,
      default: i("Clear selected")
    },
    /**
     * `aria-label` for the search input
     *
     * A descriptive `inputLabel` is preferred as this is not visible.
     */
    ariaLabelCombobox: {
      type: String,
      default: null
    },
    /**
     * `aria-label` for the listbox element
     */
    ariaLabelListbox: {
      type: String,
      default: i("Options")
    },
    /**
     * Allows to customize the `aria-label` for the deselect-option button
     * The default is "Deselect " + optionLabel
     * @type {(optionLabel: string) => string}
     */
    ariaLabelDeselectOption: {
      type: Function,
      default: (l) => i("Deselect {option}", { option: l })
    },
    /**
     * Append the dropdown element to the end of the body
     * and size/position it dynamically.
     *
     * @see https://vue-select.org/api/props.html#appendtobody
     */
    appendToBody: {
      type: Boolean,
      default: !0
    },
    /**
     * When `appendToBody` is true, this function is responsible for
     * positioning the drop down list.
     *
     * If a function is returned from `calculatePosition`, it will
     * be called when the drop down list is removed from the DOM.
     * This allows for any garbage collection you may need to do.
     *
     * @see https://vue-select.org/api/props.html#calculateposition
     */
    calculatePosition: {
      type: Function,
      default: null
    },
    /**
     * Close the dropdown when selecting an option
     *
     * @see https://vue-select.org/api/props.html#closeonselect
     */
    closeOnSelect: {
      type: Boolean,
      default: !0
    },
    /**
     * Replace default vue-select components
     *
     * @see https://vue-select.org/api/props.html#components
     */
    components: {
      type: Object,
      default: () => ({
        Deselect: {
          render: (l) => l(C, {
            props: {
              size: 20,
              fillColor: "var(--vs-controls-color)"
            },
            style: {
              cursor: "pointer"
            }
          })
        }
      })
    },
    /**
     * Sets the maximum number of options to display in the dropdown list
     */
    limit: {
      type: Number,
      default: null
    },
    /**
     * Disable the component
     *
     * @see https://vue-select.org/api/props.html#disabled
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Determines whether the dropdown should be open.
     * Receives the component instance as the only argument.
     *
     * @see https://vue-select.org/api/props.html#dropdownshouldopen
     */
    dropdownShouldOpen: {
      type: Function,
      default: ({ noDrop: l, open: e }) => l ? !1 : e
    },
    /**
     * Callback to determine if the provided option should
     * match the current search text. Used to determine
     * if the option should be displayed.
     *
     * Defaults to the internal vue-select function documented at the link
     * below
     *
     * Enabling `userSelect` will automatically set this to filter by the
     * `displayName` and `subname` properties of the user option object
     * unless this prop is set explicitly
     *
     * @see https://vue-select.org/api/props.html#filterby
     */
    filterBy: {
      type: Function,
      default: null
    },
    /**
     * Class for the `input`
     *
     * Necessary for use in NcActionInput
     */
    inputClass: {
      type: [String, Object],
      default: null
    },
    /**
     * Input element id
     */
    inputId: {
      type: String,
      default: () => "select-input-".concat(p())
    },
    /**
     * Visible label for the input element
     *
     * @todo Set default for @nextcloud/vue 9
     */
    inputLabel: {
      type: String,
      default: null
    },
    /**
     * Pass true if you are using an external label
     */
    labelOutside: {
      type: Boolean,
      default: !1
    },
    /**
     * Display a visible border around dropdown options
     * which have keyboard focus
     */
    keyboardFocusBorder: {
      type: Boolean,
      default: !0
    },
    /**
     * Key of the displayed label for object options
     *
     * Defaults to the internal vue-select string documented at the link
     * below
     *
     * Enabling `userSelect` will automatically set this to `'displayName'`
     * unless this prop is set explicitly
     *
     * @see https://vue-select.org/api/props.html#label
     */
    label: {
      type: String,
      default: null
    },
    /**
     * Show the loading icon
     *
     * @see https://vue-select.org/api/props.html#loading
     */
    loading: {
      type: Boolean,
      default: !1
    },
    /**
     * Allow selection of multiple options
     *
     * @see https://vue-select.org/api/props.html#multiple
     */
    multiple: {
      type: Boolean,
      default: !1
    },
    /**
     * Disable automatic wrapping when selected options overflow the width
     */
    noWrap: {
      type: Boolean,
      default: !1
    },
    /**
     * Array of options
     *
     * @type {Array<string | number | Record<string | number, any>>}
     *
     * @see https://vue-select.org/api/props.html#options
     */
    options: {
      type: Array,
      default: () => []
    },
    /**
     * Placeholder text
     *
     * @see https://vue-select.org/api/props.html#placeholder
     */
    placeholder: {
      type: String,
      default: ""
    },
    /**
     * Customized component's response to keydown events while the search input has focus
     *
     * @see https://vue-select.org/guide/keydown.html#mapkeydown
     */
    mapKeydown: {
      type: Function,
      /**
       * Patched Vue-Select keydown events handlers map to stop Escape propagation in open select
       *
       * @param {Record<number, Function>} map - Mapped keyCode to handlers { <keyCode>:<callback> }
       * @param {import('@nextcloud/vue-select').VueSelect} vm - VueSelect instance
       * @return {Record<number, Function>} patched keydown event handlers
       */
      default(l, e) {
        return {
          ...l,
          /**
           * Patched Escape handler to stop propagation from open select
           *
           * @param {KeyboardEvent} event - default keydown event handler
           */
          27: (a) => {
            e.open && a.stopPropagation(), l[27](a);
          }
        };
      }
    },
    /**
     * A unique identifier used to generate IDs and DOM attributes. Must be unique for every instance of the component.
     *
     * @see https://vue-select.org/api/props.html#uid
     */
    uid: {
      type: String,
      default: () => p()
    },
    /**
     * When `appendToBody` is true, this sets the placement of the dropdown
     *
     * @type {'bottom' | 'top'}
     */
    placement: {
      type: String,
      default: "bottom"
    },
    /**
     * If false, the focused dropdown option will not be reset when filtered
     * options change
     */
    resetFocusOnOptionsChange: {
      type: Boolean,
      default: !0
    },
    /**
     * Enable the user selector with avatars
     *
     * Objects must contain the data expected by the
     * [NcListItemIcon](#/Components/NcListItemIcon) and
     * [NcAvatar](#/Components/NcAvatar) components
     */
    userSelect: {
      type: Boolean,
      default: !1
    },
    /**
     * Currently selected value
     *
     * The `v-model` directive may be used for two-way data binding
     *
     * @type {string | number | Record<string | number, any> | Array<any>}
     *
     * @see https://vue-select.org/api/props.html#value
     */
    value: {
      type: [String, Number, Object, Array],
      default: null
    },
    /**
     * Enable if a value is required for native form validation
     */
    required: {
      type: Boolean,
      default: !1
    },
    /**
     * Any available prop
     *
     * @see https://vue-select.org/api/props.html
     */
    // Not an actual prop but needed to show in vue-styleguidist docs
    // eslint-disable-next-line
    " ": {}
  },
  emits: [
    /**
     * All events from https://vue-select.org/api/events.html
     */
    // Not an actual event but needed to show in vue-styleguidist docs
    " "
  ],
  data() {
    return {
      search: ""
    };
  },
  computed: {
    inputRequired() {
      return this.required ? this.value === null || Array.isArray(this.value) && this.value.length === 0 : null;
    },
    localCalculatePosition() {
      return this.calculatePosition !== null ? this.calculatePosition : (l, e, { width: a }) => {
        l.style.width = a;
        const t = {
          name: "addClass",
          fn(s) {
            return l.classList.add("vs__dropdown-menu--floating"), {};
          }
        }, r = {
          name: "togglePlacementClass",
          fn({ placement: s }) {
            return e.$el.classList.toggle(
              "select--drop-up",
              s === "top"
            ), l.classList.toggle(
              "vs__dropdown-menu--floating-placement-top",
              s === "top"
            ), {};
          }
        }, o = () => {
          m(e.$refs.toggle, l, {
            placement: this.placement,
            middleware: [
              b(-1),
              t,
              r,
              // Match popperjs default collision prevention behavior by appending the following middleware in order
              y(),
              h({ limiter: g() })
            ]
          }).then(({ x: s, y: f }) => {
            Object.assign(l.style, {
              left: "".concat(s, "px"),
              top: "".concat(f, "px"),
              width: "".concat(e.$refs.toggle.getBoundingClientRect().width, "px")
            });
          });
        };
        return d(
          e.$refs.toggle,
          l,
          o
        );
      };
    },
    localFilterBy() {
      const l = /[^<]*<([^>]+)/;
      return this.filterBy !== null ? this.filterBy : this.userSelect ? (e, a, t) => {
        var o, u, s;
        const r = t.match(l);
        return r && ((s = (u = (o = e.subname) == null ? void 0 : o.toLocaleLowerCase) == null ? void 0 : u.call(o)) == null ? void 0 : s.indexOf(r[1].toLocaleLowerCase())) > -1 || "".concat(a, " ").concat(e.subname).toLocaleLowerCase().indexOf(t.toLocaleLowerCase()) > -1;
      } : n.props.filterBy.default;
    },
    localLabel() {
      return this.label !== null ? this.label : this.userSelect ? "displayName" : n.props.label.default;
    },
    propsToForward() {
      const l = [
        ...Object.keys(n.props),
        ...n.mixins.flatMap((t) => {
          var r;
          return Object.keys((r = t.props) != null ? r : {});
        })
      ];
      return {
        ...Object.fromEntries(
          Object.entries(this.$props).filter(([t, r]) => l.includes(t))
        ),
        // Custom overrides of vue-select props
        calculatePosition: this.localCalculatePosition,
        filterBy: this.localFilterBy,
        label: this.localLabel
      };
    }
  },
  mounted() {
    !this.labelOutside && !this.inputLabel && !this.ariaLabelCombobox && c.util.warn("[NcSelect] An `inputLabel` or `ariaLabelCombobox` should be set. If an external label is used, `labelOutside` should be set to `true`."), this.inputLabel && this.ariaLabelCombobox && c.util.warn("[NcSelect] Only one of `inputLabel` or `ariaLabelCombobox` should to be set.");
  },
  methods: {
    t: i
  }
};
var x = function() {
  var e = this, a = e._self._c;
  return a("VueSelect", e._g(e._b({ staticClass: "select", class: {
    "select--no-wrap": e.noWrap,
    "user-select": e.userSelect
  }, on: { search: (t) => e.search = t }, scopedSlots: e._u([!e.labelOutside && e.inputLabel ? { key: "header", fn: function() {
    return [a("label", { staticClass: "select__label", attrs: { for: e.inputId } }, [e._v(" " + e._s(e.inputLabel) + " ")])];
  }, proxy: !0 } : null, { key: "search", fn: function({ attributes: t, events: r }) {
    return [a("input", e._g(e._b({ class: ["vs__search", e.inputClass], attrs: { required: e.inputRequired } }, "input", t, !1), r))];
  } }, { key: "open-indicator", fn: function({ attributes: t }) {
    return [a("ChevronDown", e._b({ style: {
      cursor: e.disabled ? null : "pointer"
    }, attrs: { "fill-color": "var(--vs-controls-color)", size: 26 } }, "ChevronDown", t, !1))];
  } }, { key: "option", fn: function(t) {
    return [e.userSelect ? a("NcListItemIcon", e._b({ attrs: { "avatar-size": 24, name: t[e.localLabel], search: e.search } }, "NcListItemIcon", t, !1)) : a("NcEllipsisedOption", { attrs: { name: String(t[e.localLabel]), search: e.search } })];
  } }, { key: "selected-option", fn: function(t) {
    return [e.userSelect ? a("NcListItemIcon", e._b({ attrs: { "avatar-size": 24, name: t[e.localLabel], search: e.search } }, "NcListItemIcon", t, !1)) : a("NcEllipsisedOption", { attrs: { name: String(t[e.localLabel]), search: e.search } })];
  } }, { key: "spinner", fn: function(t) {
    return [t.loading ? a("NcLoadingIcon") : e._e()];
  } }, { key: "no-options", fn: function() {
    return [e._v(" " + e._s(e.t("No results")) + " ")];
  }, proxy: !0 }, e._l(e.$scopedSlots, function(t, r) {
    return { key: r, fn: function(o) {
      return [e._t(r, null, null, o)];
    } };
  })], null, !0) }, "VueSelect", e.propsToForward, !1), e.$listeners));
}, I = [], F = /* @__PURE__ */ B(
  w,
  x,
  I,
  !1,
  null,
  null,
  null,
  null
);
const G = F.exports;
export {
  G as N
};
